import { LoadingView } from '_/components';
import React from 'react';

const LoadingAppScreen: React.FC = () => {
  return <LoadingView />;
};

export default LoadingAppScreen;
